export function getNotificationLanguage(workspace) {
    return workspace.language ?? 'cs';
}